import type { EpgGridTimelineAnchor } from "$src/core/models/epg";

const isLiveClockEnabled = ({
  highlightLivePrograms,
  timelineScrollAnchor,
}: {
  highlightLivePrograms: boolean;
  timelineScrollAnchor?: EpgGridTimelineAnchor;
}): boolean =>
  highlightLivePrograms && timelineScrollAnchor?.selectedDateOffset === 0;

export default isLiveClockEnabled;
